"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _date_area_component = _interopRequireDefault(require("./date_area_component"));

var _spauiButton = _interopRequireDefault(require("@tencent/spaui-button"));

var _shortcut_panel = _interopRequireDefault(require("../panel/shortcut_panel"));

var _data = require("../config/data");

var _spauiUtils = require("@tencent/spaui-utils");

var _index = require("../utils/index");

var _spauiTimepicker = _interopRequireDefault(require("@tencent/spaui-timepicker"));

var _datepicker_compact_props = _interopRequireDefault(require("../datepicker_compact_props"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 * @class
 */
var RangeDatePanel =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(RangeDatePanel, _PureComponent);

  function RangeDatePanel(props) {
    var _this;

    _classCallCheck(this, RangeDatePanel);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RangeDatePanel).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "componentDidMount", function () {
      var useNewUI = _this.props.useNewUI;

      if (_this.dataPanel && useNewUI) {
        var dataPanel = _this.dataPanel.getBoundingClientRect() || {};
        _this.dataPanelHeight = dataPanel.height || undefined;
        var dateArea = _this.dateAreaDom.getBoundingClientRect() || {};
        _this.dateAreaHeight = dateArea.height || undefined;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "toggleDateOrTimePicker", function () {
      _this.setState(function (state) {
        return {
          showDatePicker: !state.showDatePicker
        };
      });
    });

    _this.state = {
      startData: props.startData || {},
      endData: props.endData || {},
      showDatePicker: true,
      // 显示日期选择器（为 false 则显示时间选择器，只用于新版 UI）
      // 鼠标当前 hover 对应的时间
      hoverYear: 0,
      hoverMonth: 0,
      hoverDate: 0
    }; // 用于记录下拉面板的高度，便于切换选择时间的时候，防止下拉面板的跳动

    _this.dataPanelHeight = undefined;
    _this.handleSubmit = _this.handleSubmit.bind(_assertThisInitialized(_this));
    _this.handleChange = _this.handleChange.bind(_assertThisInitialized(_this));
    _this.handleStartTimePickerChange = _this.handleStartTimePickerChange.bind(_assertThisInitialized(_this));
    _this.handleEndTimePickerChange = _this.handleEndTimePickerChange.bind(_assertThisInitialized(_this));
    _this.changeHoverDate = (0, _index.throttle)(_this.changeHoverDate.bind(_assertThisInitialized(_this)), 50);

    _this.nullList();

    return _this;
  }

  _createClass(RangeDatePanel, [{
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      if ((0, _index.isNotEqualByObject)(nextProps.startData, this.props.startData)) {
        this.setState({
          startData: nextProps.startData
        });
      }

      if ((0, _index.isNotEqualByObject)(nextProps.endData, this.props.endData)) {
        this.setState({
          endData: nextProps.endData
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.nullList();
    }
  }, {
    key: "nullList",
    value: function nullList() {
      this.dataPanel = null;
      this.dateAreaDom = null;
      this.startDateDom = null;
      this.endDateDom = null;
    }
    /**
     * 改变鼠标 hover 的日期
     *
     * @param {number} hoverYear 年
     * @param {number} hoverMonth 月
     * @param {number} hoverDate 日
     * @memberof RangeDatePanel
     */

  }, {
    key: "changeHoverDate",
    value: function changeHoverDate(hoverYear, hoverMonth, hoverDate) {
      this.setState({
        hoverYear: hoverYear,
        hoverMonth: hoverMonth,
        hoverDate: hoverDate
      });
    } // 提交选择的数据

  }, {
    key: "handleSubmit",
    value: function handleSubmit(event) {
      var _this$state = this.state,
          startData = _this$state.startData,
          endData = _this$state.endData;
      var _this$props = this.props,
          onSubmit = _this$props.onSubmit,
          canChooseOneDateByRange = _this$props.canChooseOneDateByRange;
      var tempData = null;
      var startTime = 0;
      var endTime = 0;

      if (startData.year && endData.year) {
        startTime = new Date(startData.year, startData.month || 0, startData.date || 0, startData.hour || 0, startData.minute || 0, startData.second || 0).getTime();
        endTime = new Date(endData.year, endData.month || 0, endData.date || 0, endData.hour || 0, endData.minute || 0, endData.second || 0).getTime();

        if (startTime > endTime) {
          tempData = _objectSpread({}, startData);
          startData = endData;
          endData = tempData;
        }
      }

      if ((0, _spauiUtils.isFunction)(onSubmit)) {
        if (canChooseOneDateByRange && startData.year && !endData.year) {
          endData = startData;
        }

        onSubmit(event, startData, endData);
      }
    } // 响应日期选择

  }, {
    key: "handleChange",
    value: function handleChange(event, type, data) {
      var _this2 = this;

      var _this$props2 = this.props,
          onRealtimeChange = _this$props2.onRealtimeChange,
          startDateDisabled = _this$props2.startDateDisabled,
          endDateDisabled = _this$props2.endDateDisabled,
          optionalStartDateData = _this$props2.optionalStartDateData,
          optionalEndDateData = _this$props2.optionalEndDateData,
          timePicker = _this$props2.timePicker,
          hideSubmitButton = _this$props2.hideSubmitButton,
          autoSelectEndDate = _this$props2.autoSelectEndDate,
          shortestRange = _this$props2.shortestRange,
          longestRange = _this$props2.longestRange,
          picker = _this$props2.picker;
      var _this$state2 = this.state,
          startData = _this$state2.startData,
          endData = _this$state2.endData;
      var limitTime = optionalStartDateData.hour > 0 || optionalStartDateData.minute > 0 || optionalStartDateData.second > 0 || typeof optionalEndDateData.hour !== 'undefined';
      var result = {
        startData: startData,
        endData: endData
      };
      var tempData = {}; // 没有都被禁止才做响应

      if (!startDateDisabled || !endDateDisabled) {
        if (startDateDisabled) {
          // 开始日期被禁止，那就只有结束日期的变更，且必须是在结束日期面板做选择
          if (type === 'start' || type === 'end') {
            result.endData = _objectSpread({}, endData, {}, data);
          }
        } else if (endDateDisabled) {
          // 结束日期被禁止，那就只有开始日期的变更，且必须是在开始日期面板做选择
          if (type === 'start' || type === 'end') {
            result.startData = _objectSpread({}, startData, {}, data);
          }
        } else {
          // 如果原来两个日期都已经选择，再次选择就需要先清空，只保留时分秒
          if (startData && startData.year && endData && endData.year) {
            // 没有限制日期才保留
            if (!limitTime) {
              result = {
                startData: {
                  hour: startData.hour,
                  minute: endData.minute,
                  second: endData.second
                },
                endData: {
                  hour: endData.hour,
                  minute: endData.minute,
                  second: endData.second
                }
              };
            } else {
              result = {
                startData: {},
                endData: {}
              };
            }
          } // 如果都为空，那就先放在开始日期


          if (!result.startData.year && !result.endData.year) {
            result.startData = _objectSpread({}, result.startData, {}, data); // 如果需要自动设置结束时间

            if (autoSelectEndDate && shortestRange && longestRange && shortestRange === longestRange) {
              var newStartDate = result.startData;
              var startDateTime = new Date(newStartDate.year, newStartDate.month, newStartDate.date);
              var endDate = new Date(startDateTime.getTime() + shortestRange * _data.ONE_DAY_TIME);
              var endDateData = {
                year: endDate.getFullYear(),
                month: endDate.getMonth(),
                date: endDate.getDate()
              }; // 该时间在可选择的范围内，则设置成截止时间

              if ((0, _index.compareDate)(optionalEndDateData, endDateData) >= 0) {
                result.endData = _objectSpread({}, result.endData, {
                  year: endDate.getFullYear(),
                  month: endDate.getMonth(),
                  date: endDate.getDate()
                });
              }
            }
          } else {
            // 判断下日期顺序
            if (result.startData.year) {
              tempData = result.startData;
            } else {
              tempData = result.endData;
            }

            if (new Date(data.year, data.month, picker === 'date' ? data.date : 0).getTime() > new Date(tempData.year, tempData.month, picker === 'date' ? tempData.date : 0).getTime()) {
              result = {
                startData: tempData,
                endData: _objectSpread({}, result.endData, {}, data)
              };
            } else {
              if (result.startData.year && limitTime) {
                tempData = {
                  year: tempData.year,
                  month: tempData.month,
                  date: tempData.date
                };
              }

              result = {
                startData: _objectSpread({}, result.startData, {}, data),
                endData: tempData
              };
            }
          }
        }

        this.setState(result, function () {
          // 如果存在时分，则默认选中第一个可选的时分
          if (timePicker) {
            _this2.setDefaultTimePickerValue();
          } // 选择时分的不支持


          if (!_this2.isDisabled() && !timePicker && hideSubmitButton) {
            _this2.handleSubmit(event);
          }
        });

        if ((0, _spauiUtils.isFunction)(onRealtimeChange)) {
          onRealtimeChange(event, 'range', {
            startData: result.startData,
            endData: result.endData
          });
        }
      }
    } // 时分秒组件变更

  }, {
    key: "handleTimePickerChange",
    value: function handleTimePickerChange(event, type) {
      var value = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var callback = arguments.length > 3 ? arguments[3] : undefined;
      var onRealtimeChange = this.props.onRealtimeChange;
      var timeArr = value.split(':') || [];
      var timeData = {
        hour: timeArr[0] || 0,
        minute: timeArr[1] || 0,
        second: timeArr[2] || 0
      };
      var _this$state3 = this.state,
          startData = _this$state3.startData,
          endData = _this$state3.endData;
      var finalStartData = startData;
      var finalEndData = endData;

      if (type === 'start') {
        finalStartData = (0, _spauiUtils.objectAssign)({}, startData, timeData);
      } else {
        finalEndData = (0, _spauiUtils.objectAssign)({}, endData, timeData);
      }

      this.setState({
        startData: finalStartData,
        endData: finalEndData
      }, callback);

      if ((0, _spauiUtils.isFunction)(onRealtimeChange)) {
        onRealtimeChange(event, 'range', {
          startData: finalStartData,
          endData: finalEndData
        });
      }
    } // 开始时分秒组件变更

  }, {
    key: "handleStartTimePickerChange",
    value: function handleStartTimePickerChange(event) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.handleTimePickerChange(event, 'start', value);
    } // 结束时分秒组件变更

  }, {
    key: "handleEndTimePickerChange",
    value: function handleEndTimePickerChange(event) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      this.handleTimePickerChange(event, 'end', value);
    } // 获取时分秒组件的值

  }, {
    key: "getTimeValue",
    value: function getTimeValue() {
      var _this$props3 = this.props,
          timePicker = _this$props3.timePicker,
          _this$props3$startTim = _this$props3.startTimePickerProps,
          startTimePickerProps = _this$props3$startTim === void 0 ? {} : _this$props3$startTim,
          endTimePickerProps = _this$props3.endTimePickerProps;
      var startTimeList = startTimePickerProps.timeList;
      var endTimeList = endTimePickerProps.timeList;
      var _this$state4 = this.state,
          startData = _this$state4.startData,
          endData = _this$state4.endData;
      var startTimeValue = '';
      var endTimeValue = ''; // 有开启时分组件才进行计算

      if (timePicker) {
        startTimeValue = (0, _index.getStringTimeByData)(startData);
        endTimeValue = (0, _index.getStringTimeByData)(endData); // 如果有timeList，初始化时会用第一个做数据转化，所以这里替换成原来的item数据

        startTimeValue = (0, _index.getRowDataByTimeList)(startTimeList, startTimeValue); // 如果有timeList，初始化时会用第一个做数据转化，所以这里替换成原来的item数据

        endTimeValue = (0, _index.getRowDataByTimeList)(endTimeList, endTimeValue);
      }

      return {
        startTimeValue: startTimeValue,
        endTimeValue: endTimeValue
      };
    }
  }, {
    key: "isDisabled",
    value: function isDisabled() {
      var _this$state5 = this.state,
          _this$state5$startDat = _this$state5.startData,
          startData = _this$state5$startDat === void 0 ? {} : _this$state5$startDat,
          _this$state5$endData = _this$state5.endData,
          endData = _this$state5$endData === void 0 ? {} : _this$state5$endData;

      var _compactProps = (0, _datepicker_compact_props["default"])(this.props),
          timePicker = _compactProps.timePicker,
          clear = _compactProps.clear,
          _compactProps$canChoo = _compactProps.canChooseOneDateByRange,
          canChooseOneDateByRange = _compactProps$canChoo === void 0 ? true : _compactProps$canChoo,
          picker = _compactProps.picker;

      var _this$getTimeValue = this.getTimeValue(),
          startTimeValue = _this$getTimeValue.startTimeValue,
          endTimeValue = _this$getTimeValue.endTimeValue;

      var disabled = false;

      if (picker === 'date' || picker === 'week') {
        disabled = !(startData.date && endData.date);
      } else if (picker === 'month') {
        disabled = !((0, _spauiUtils.isNumber)(startData.month) && (0, _spauiUtils.isNumber)(endData.month));
      }

      if (timePicker) {
        disabled = !(startData.date && endData.date && startTimeValue && endTimeValue);
      } else if (canChooseOneDateByRange) {
        if (startData.date && picker === 'date' || startData.month && picker === 'month') {
          disabled = false;
        }
      } // 如果允许清空，就不进行确定按钮disabled


      if (clear && disabled && !startData.year && !endData.year) {
        disabled = false;
      }

      return disabled;
    } // 根据日期数据获取字符串的时分秒格式，比如：10:00:00

  }, {
    key: "getTimeIsString",
    value: function getTimeIsString(dateObject) {
      var toString = Array.prototype.toString;
      var result = '';
      var dateObjectHour;
      var dateObjectMinute;
      var dateObjectSecond;

      if (_typeof(dateObject) === 'object' && dateObject) {
        if (toString.call(dateObject) === '[object Date]') {
          dateObjectHour = dateObject.getHours();
          dateObjectMinute = dateObject.getMinutes();
          dateObjectSecond = dateObject.getSeconds();
        } else {
          dateObjectHour = dateObject.hour || '00';
          dateObjectMinute = dateObject.minute || '00';
          dateObjectSecond = dateObject.second || '00';
        }

        result = [dateObjectHour, dateObjectMinute, dateObjectSecond].join(':');
      }

      return result;
    } // 日期是否相等

  }, {
    key: "dateIsEuqal",
    value: function dateIsEuqal(fromDateObject, toDateObject) {
      var toString = Array.prototype.toString;
      var result = false;
      var yearOfFromDate;
      var monthOfFromDate;
      var dateOfFromDate;
      var yearOfToDate;
      var monthOfToDate;
      var dateOfToDate;

      if (_typeof(fromDateObject) === 'object' && fromDateObject && _typeof(toDateObject) === 'object' && toDateObject) {
        if (toString.call(fromDateObject) === '[object Date]') {
          yearOfFromDate = fromDateObject.getFullYear();
          monthOfFromDate = fromDateObject.getMonth();
          dateOfFromDate = fromDateObject.getDate();
        } else {
          yearOfFromDate = fromDateObject.year;
          monthOfFromDate = fromDateObject.month;
          dateOfFromDate = fromDateObject.date;
        }

        if (toString.call(toDateObject) === '[object Date]') {
          yearOfToDate = toDateObject.getFullYear();
          monthOfToDate = toDateObject.getMonth();
          dateOfToDate = toDateObject.getDate();
        } else {
          yearOfToDate = toDateObject.year;
          monthOfToDate = toDateObject.month;
          dateOfToDate = toDateObject.date;
        }

        if (yearOfFromDate === yearOfToDate && monthOfFromDate === monthOfToDate && dateOfFromDate === dateOfToDate) {
          result = true;
        }
      }

      return result;
    } // 获取有时分长度限制后的日期

  }, {
    key: "getDateByTimeRange",
    value: function getDateByTimeRange(dateObject) {
      var timeRange = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var date = null;
      var timeStamp = 0;

      if (_typeof(dateObject) === 'object' && dateObject) {
        date = new Date(dateObject.year, dateObject.month, dateObject.date, dateObject.hour || 0, dateObject.minute || 0, dateObject.second || 0);
        timeStamp = date.getTime() + timeRange;
        date = new Date(timeStamp);
      }

      return {
        timeStamp: timeStamp,
        date: date
      };
    } // 获取时刻表的额外属性

  }, {
    key: "getExtraTimePickerProps",
    value: function getExtraTimePickerProps() {
      var _compactProps2 = (0, _datepicker_compact_props["default"])(this.props),
          _compactProps2$startT = _compactProps2.startTimePickerProps,
          startTimePickerProps = _compactProps2$startT === void 0 ? {} : _compactProps2$startT,
          optionalStartDateData = _compactProps2.optionalStartDateData,
          timePicker = _compactProps2.timePicker,
          maxTimeRange = _compactProps2.maxTimeRange,
          minTimeRange = _compactProps2.minTimeRange,
          optionalEndDateObject = _compactProps2.optionalEndDateObject,
          optionalStartDateObject = _compactProps2.optionalStartDateObject,
          optionalEndDateData = _compactProps2.optionalEndDateData;

      var _this$state6 = this.state,
          _this$state6$startDat = _this$state6.startData,
          startData = _this$state6$startDat === void 0 ? {} : _this$state6$startDat,
          _this$state6$endData = _this$state6.endData,
          endData = _this$state6$endData === void 0 ? {} : _this$state6$endData;

      var _this$getTimeValue2 = this.getTimeValue(),
          startTimeValue = _this$getTimeValue2.startTimeValue,
          endTimeValue = _this$getTimeValue2.endTimeValue;

      var startTimePickerBeginTime = '';
      var startTimePickerEndTime = '';
      var endTimePickerBeginTime = '';
      var endTimePickerEndTime = '';
      var timePickerBeginTime = '';
      var timePickerEndTime = '';
      var startTimeDateObject = null;
      var endTimeDateObject = null;
      var startTimePickerListCanUse = true;
      var endTimePickerListCanUse = true;
      var dateByTimeRange = {};

      if (timePicker) {
        if (typeof optionalStartDateData.hour !== 'undefined') {
          timePickerBeginTime = this.getTimeIsString(optionalStartDateData);
        }

        if (typeof optionalEndDateData.hour !== 'undefined') {
          timePickerEndTime = this.getTimeIsString(optionalEndDateData);
        } // 选择了最开始或者最末尾的那天，就得看下小时的选择是否限制下选项


        if (this.dateIsEuqal(startData, optionalStartDateData)) {
          startTimePickerBeginTime = timePickerBeginTime;
        }

        if (this.dateIsEuqal(startData, optionalEndDateData)) {
          startTimePickerEndTime = timePickerEndTime;
        }

        if (this.dateIsEuqal(endData, optionalStartDateData)) {
          endTimePickerBeginTime = timePickerBeginTime;
        }

        if (this.dateIsEuqal(endData, optionalEndDateData)) {
          endTimePickerEndTime = timePickerEndTime;
        } // 如果设置了毫秒级的时间限制，在选择第一个小时之后，需要看下第二个小时的限制
        // 且两个日期都选择了


        if ((typeof maxTimeRange !== 'undefined' || typeof minTimeRange !== 'undefined') && startData.year && endData.year) {
          // 已经选择了开始日期
          if (startTimeValue) {
            if (typeof maxTimeRange !== 'undefined') {
              dateByTimeRange = this.getDateByTimeRange(startData, maxTimeRange);
              startTimeDateObject = dateByTimeRange.date; // 如果加上最大长度的限制后已经超过了可选结束时间的话，就不需要把timePickerEndTime置换一下

              if (startTimeDateObject.getTime() < optionalEndDateObject.getTime()) {
                timePickerEndTime = this.getTimeIsString(startTimeDateObject);

                if (this.dateIsEuqal(startData, startTimeDateObject)) {
                  startTimePickerEndTime = timePickerEndTime;
                }

                if (this.dateIsEuqal(endData, startTimeDateObject)) {
                  endTimePickerEndTime = timePickerEndTime;
                }

                var endDateTime = new Date(endData.year, endData.month, endData.date).getTime(); // 大于可选时间的话，就都不能选

                if (endDateTime > dateByTimeRange.timeStamp) {
                  endTimePickerBeginTime = '00:01';
                  endTimePickerEndTime = '00:00';
                  endTimePickerListCanUse = false;
                }
              }
            }

            if (typeof minTimeRange !== 'undefined' && minTimeRange > 0 && endTimePickerListCanUse) {
              dateByTimeRange = this.getDateByTimeRange(startData, minTimeRange);
              startTimeDateObject = dateByTimeRange.date; // 如果加上最大长度的限制后已经超过了可选结束时间的话，就不需要把timePickerEndTime置换一下

              if (startTimeDateObject.getTime() < optionalEndDateObject.getTime()) {
                timePickerBeginTime = this.getTimeIsString(startTimeDateObject);

                if (this.dateIsEuqal(endData, startTimeDateObject)) {
                  endTimePickerBeginTime = timePickerBeginTime;
                }
              }
            }
          }

          if (endTimeValue) {
            // 已经选择了结束日期
            if (typeof maxTimeRange !== 'undefined') {
              dateByTimeRange = this.getDateByTimeRange(endData, -maxTimeRange);
              endTimeDateObject = dateByTimeRange.date; // 如果加上最大长度的限制后已经超过了可选结束时间的话，就不需要把timePickerEndTime置换一下

              if (endTimeDateObject.getTime() > optionalStartDateObject.getTime()) {
                timePickerBeginTime = this.getTimeIsString(endTimeDateObject);

                if (this.dateIsEuqal(startData, endTimeDateObject)) {
                  startTimePickerBeginTime = timePickerBeginTime;
                }

                if (this.dateIsEuqal(endData, endTimeDateObject)) {
                  endTimePickerBeginTime = timePickerBeginTime;
                } // 大于可选时间的话，就都不能选
                // 如果是自己的列表的话，得看下最后的时间是啥


                if (startTimePickerProps && startTimePickerProps.timeList.length > 0) {
                  var startDataDate = "".concat(startData.year, "-").concat(startData.month + 1, "-").concat(startData.date);

                  if (new Date("".concat(startDataDate, " ").concat(startTimePickerProps.timeList[startTimePickerProps.timeList.length - 1])).getTime() < dateByTimeRange.timeStamp) {
                    startTimePickerBeginTime = '00:01';
                    startTimePickerEndTime = '00:00';
                    startTimePickerListCanUse = false;
                  }
                } else if (new Date(startData.year, startData.month, startData.date, 23, 59, 59).getTime() < dateByTimeRange.timeStamp) {
                  startTimePickerBeginTime = '00:01';
                  startTimePickerEndTime = '00:00';
                  startTimePickerListCanUse = false;
                }
              }
            } // 已经选择了结束日期


            if (typeof minTimeRange !== 'undefined' && minTimeRange > 0 && startTimePickerListCanUse) {
              dateByTimeRange = this.getDateByTimeRange(endData, -minTimeRange);
              endTimeDateObject = dateByTimeRange.date; // 如果加上最大长度的限制后已经超过了可选结束时间的话，就不需要把timePickerEndTime置换一下

              if (endTimeDateObject.getTime() > optionalStartDateObject.getTime()) {
                timePickerBeginTime = this.getTimeIsString(endTimeDateObject);

                if (this.dateIsEuqal(startData, endTimeDateObject)) {
                  startTimePickerEndTime = timePickerBeginTime;
                }
              }
            }
          }
        }
      }

      return {
        startTimePickerBeginTime: startTimePickerBeginTime,
        startTimePickerEndTime: startTimePickerEndTime,
        endTimePickerBeginTime: endTimePickerBeginTime,
        endTimePickerEndTime: endTimePickerEndTime
      };
    } // 选中日期后默认选中第一个可选的时间

  }, {
    key: "setDefaultTimePickerValue",
    value: function setDefaultTimePickerValue() {
      var _this3 = this;

      var _compactProps3 = (0, _datepicker_compact_props["default"])(this.props),
          _compactProps3$startT = _compactProps3.startTimePickerProps,
          startTimePickerProps = _compactProps3$startT === void 0 ? {} : _compactProps3$startT,
          _compactProps3$endTim = _compactProps3.endTimePickerProps,
          endTimePickerProps = _compactProps3$endTim === void 0 ? {} : _compactProps3$endTim;

      var _this$state7 = this.state,
          _this$state7$startDat = _this$state7.startData,
          startData = _this$state7$startDat === void 0 ? {} : _this$state7$startDat,
          _this$state7$endData = _this$state7.endData,
          endData = _this$state7$endData === void 0 ? {} : _this$state7$endData;
      var _startTimePickerProps = startTimePickerProps.timeList,
          startTimeList = _startTimePickerProps === void 0 ? [] : _startTimePickerProps;
      var _endTimePickerProps$t = endTimePickerProps.timeList,
          endTimeList = _endTimePickerProps$t === void 0 ? [] : _endTimePickerProps$t;

      var _this$getExtraTimePic = this.getExtraTimePickerProps(),
          startTimePickerBeginTime = _this$getExtraTimePic.startTimePickerBeginTime,
          startTimePickerEndTime = _this$getExtraTimePic.startTimePickerEndTime,
          endTimePickerBeginTime = _this$getExtraTimePic.endTimePickerBeginTime,
          endTimePickerEndTime = _this$getExtraTimePic.endTimePickerEndTime;

      var _this$getTimeValue3 = this.getTimeValue(),
          startTimeValue = _this$getTimeValue3.startTimeValue,
          endTimeValue = _this$getTimeValue3.endTimeValue; // 更新起始可选时间和结束时间


      var updateStartTimePicker = undefined;
      var updateEndTimePicker = undefined; // 选择了起始时间和结束时间, 则默认选中第一个可选的时间

      if (startData.date && endData.date) {
        if (!startTimeValue) {
          var _loop = function _loop(i) {
            var isDisabled = _this3.isTimeDisabled(startTimeList[i], startTimePickerBeginTime, startTimePickerEndTime);

            if (!isDisabled) {
              updateStartTimePicker = function updateStartTimePicker(callback) {
                _this3.handleTimePickerChange(event, 'start', startTimeList[i], callback);
              };

              return "break";
            }
          };

          for (var i = 0; i < startTimeList.length; i++) {
            var _ret = _loop(i);

            if (_ret === "break") break;
          }
        }

        if (!endTimeValue) {
          var _loop2 = function _loop2(_i) {
            var isDisabled = _this3.isTimeDisabled(endTimeList[_i], endTimePickerBeginTime, endTimePickerEndTime);

            if (!isDisabled) {
              updateEndTimePicker = function updateEndTimePicker(callback) {
                _this3.handleTimePickerChange(event, 'end', endTimeList[_i], callback);
              };

              return "break";
            }
          };

          for (var _i = 0; _i < endTimeList.length; _i++) {
            var _ret2 = _loop2(_i);

            if (_ret2 === "break") break;
          }
        } // 执行更新（这里由于 setState 的异步性，所以需要利用 callback 来更新）


        if (updateStartTimePicker || updateEndTimePicker) {
          if (updateStartTimePicker) {
            updateStartTimePicker(updateEndTimePicker);
          } else {
            updateEndTimePicker(updateStartTimePicker);
          }
        }
      }
    } // 该时间是否禁止选择

  }, {
    key: "isTimeDisabled",
    value: function isTimeDisabled() {
      var itemTime = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '00:00:00';
      var startTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var endTime = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

      // 补零
      var appendZero = function appendZero() {
        var time = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
        var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 3;
        var newTime = time.slice();

        if (newTime.length != length) {
          var appendLength = length - newTime.length;

          for (var i = 0; i < appendLength; i++) {
            newTime.push('00');
          }
        }

        return newTime;
      };

      var isDisabled = false;
      var startTimeStamp;
      var endTimeStamp; // 假设三个日期，实际值没啥意义，主要是用来跟时分秒凑成一个日期和对比

      var prevDateTime = '2019-09-01 23:59:59';
      var nextDateTime = '2019-09-03 00:00:00';
      var theDate = '2019-09-02 ';
      var itemTimeArr = appendZero(itemTime.split(':'));
      var startTimeArr = appendZero(startTime ? startTime.split(':') : []);
      var endTimeArr = appendZero(endTime ? endTime.split(':') : []);
      var itemTimeStamp = new Date(theDate + itemTimeArr.join(':')).getTime();

      if (startTime === '') {
        startTimeStamp = new Date(prevDateTime).getTime();
      } else {
        startTimeStamp = new Date(theDate + startTimeArr.join(':')).getTime();
      }

      if (endTime === '') {
        endTimeStamp = new Date(nextDateTime).getTime();
      } else {
        endTimeStamp = new Date(theDate + endTimeArr.join(':')).getTime();
      }

      if (!(itemTimeStamp >= startTimeStamp && itemTimeStamp <= endTimeStamp)) {
        isDisabled = true;
      }

      return isDisabled;
    }
  }, {
    key: "showTimePickerTitle",
    value: function showTimePickerTitle() {
      var timePickerProps = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var _compactProps4 = (0, _datepicker_compact_props["default"])(this.props),
          _compactProps4$locale = _compactProps4.locale,
          locale = _compactProps4$locale === void 0 ? {} : _compactProps4$locale;

      var showSecond = !(0, _spauiUtils.isEmptyObject)(timePickerProps);
      return _react["default"].createElement("ul", {
        className: (0, _classnames["default"])('spaui-datepicker-timepicker-title clearfix', {
          'timepicker-title-with-second': showSecond
        })
      }, _react["default"].createElement("li", null, locale.hourLabel), _react["default"].createElement("li", null, locale.minuteLabel), showSecond ? _react["default"].createElement("li", null, locale.secondLabel) : null);
    } // 切换面板显示日期还是时间选择器

  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$state8 = this.state,
          _this$state8$startDat = _this$state8.startData,
          startData = _this$state8$startDat === void 0 ? {} : _this$state8$startDat,
          _this$state8$endData = _this$state8.endData,
          endData = _this$state8$endData === void 0 ? {} : _this$state8$endData,
          hoverYear = _this$state8.hoverYear,
          hoverMonth = _this$state8.hoverMonth,
          hoverDate = _this$state8.hoverDate,
          showDatePicker = _this$state8.showDatePicker;

      var _compactProps5 = (0, _datepicker_compact_props["default"])(this.props),
          onOpen = _compactProps5.onOpen,
          optionalStartDateData = _compactProps5.optionalStartDateData,
          optionalEndDateData = _compactProps5.optionalEndDateData,
          longestRange = _compactProps5.longestRange,
          shortestRange = _compactProps5.shortestRange,
          shortcuts = _compactProps5.shortcuts,
          onSubmit = _compactProps5.onSubmit,
          _compactProps5$startT = _compactProps5.startTimePickerProps,
          startTimePickerProps = _compactProps5$startT === void 0 ? {} : _compactProps5$startT,
          _compactProps5$endTim = _compactProps5.endTimePickerProps,
          endTimePickerProps = _compactProps5$endTim === void 0 ? {} : _compactProps5$endTim,
          timePicker = _compactProps5.timePicker,
          useShortcut = _compactProps5.useShortcut,
          startDateDisabled = _compactProps5.startDateDisabled,
          endDateDisabled = _compactProps5.endDateDisabled,
          nowDateObject = _compactProps5.nowDateObject,
          onYearAndMonthChange = _compactProps5.onYearAndMonthChange,
          hideSubmitButton = _compactProps5.hideSubmitButton,
          startYear = _compactProps5.startYear,
          startMonth = _compactProps5.startMonth,
          endYear = _compactProps5.endYear,
          endMonth = _compactProps5.endMonth,
          getDateValue = _compactProps5.getDateValue,
          format = _compactProps5.format,
          _compactProps5$classN = _compactProps5.classNameMap,
          classNameMap = _compactProps5$classN === void 0 ? {} : _compactProps5$classN,
          panelWeekStart = _compactProps5.panelWeekStart,
          _compactProps5$hideEn = _compactProps5.hideEndDatePanel,
          hideEndDatePanel = _compactProps5$hideEn === void 0 ? false : _compactProps5$hideEn,
          unlimitedDateValue = _compactProps5.unlimitedDateValue,
          unlimitedDateValueLabel = _compactProps5.unlimitedDateValueLabel,
          startDateCanBeUnlimited = _compactProps5.startDateCanBeUnlimited,
          endDateCanBeUnlimited = _compactProps5.endDateCanBeUnlimited,
          _compactProps5$locale = _compactProps5.locale,
          locale = _compactProps5$locale === void 0 ? {} : _compactProps5$locale,
          setLabel = _compactProps5.setLabel,
          useNewUI = _compactProps5.useNewUI,
          showPanelFooter = _compactProps5.showPanelFooter,
          picker = _compactProps5.picker,
          firstDayOfWeek = _compactProps5.firstDayOfWeek,
          endDayOfWeek = _compactProps5.endDayOfWeek,
          fixedTips = _compactProps5.fixedTips,
          fixedNumber = _compactProps5.fixedNumber,
          MonthPanelListComponent = _compactProps5.MonthPanelListComponent,
          YearPanelListComponent = _compactProps5.YearPanelListComponent;

      var _this$getTimeValue4 = this.getTimeValue(),
          startTimeValue = _this$getTimeValue4.startTimeValue,
          endTimeValue = _this$getTimeValue4.endTimeValue;

      var dateAreaConfig = {
        MonthPanelListComponent: MonthPanelListComponent,
        YearPanelListComponent: YearPanelListComponent,
        startDateDisabled: startDateDisabled,
        // 开始日期是否禁用
        endDateDisabled: endDateDisabled,
        // 结束日期是否禁用
        optionalStartDateData: optionalStartDateData,
        // 可选开始日期数据
        optionalEndDateData: optionalEndDateData,
        // 可选结束日期数据
        shortestRange: shortestRange,
        // 最短日期范围
        longestRange: longestRange,
        // 最长日期范围
        year: startYear,
        month: startMonth,
        startYear: startYear,
        startMonth: startMonth,
        endYear: endYear,
        endMonth: endMonth,
        firstDayOfWeek: firstDayOfWeek,
        endDayOfWeek: endDayOfWeek,
        fixedTips: fixedTips,
        fixedNumber: fixedNumber,
        startData: startData,
        endData: endData,
        nowDateObject: nowDateObject,
        onChange: this.handleChange,
        onYearAndMonthChange: onYearAndMonthChange,
        hideEndDatePanel: hideEndDatePanel,
        format: format,
        unlimitedDateValue: unlimitedDateValue,
        unlimitedDateValueLabel: unlimitedDateValueLabel,
        startDateCanBeUnlimited: startDateCanBeUnlimited,
        endDateCanBeUnlimited: endDateCanBeUnlimited,
        getDateValue: getDateValue,
        classNameMap: classNameMap,
        panelWeekStart: panelWeekStart,
        useShortcut: useShortcut,
        timePicker: timePicker,
        hideSubmitButton: hideSubmitButton,
        hoverYear: hoverYear,
        hoverMonth: hoverMonth,
        hoverDate: hoverDate,
        changeHoverDate: this.changeHoverDate,
        locale: locale,
        setLabel: setLabel,
        useNewUI: useNewUI,
        picker: picker
      };

      var getSplitClassName = function getSplitClassName() {
        var result = ''; // 不连续月份就需要加分割线

        if (startYear && endYear) {
          if (Math.abs(new Date(startYear, startMonth).getTime() - new Date(endYear, endMonth).getTime()) > 31 * 24 * 60 * 60 * 1000) {
            result = 'spaui-datepicker-split';
          }
        }

        return result;
      };

      var disabled = this.isDisabled(); // 获取额外的时分表的 props

      var _this$getExtraTimePic2 = this.getExtraTimePickerProps(),
          startTimePickerBeginTime = _this$getExtraTimePic2.startTimePickerBeginTime,
          startTimePickerEndTime = _this$getExtraTimePic2.startTimePickerEndTime,
          endTimePickerBeginTime = _this$getExtraTimePic2.endTimePickerBeginTime,
          endTimePickerEndTime = _this$getExtraTimePic2.endTimePickerEndTime;

      var controlStyle = {};

      if (!useShortcut && !timePicker && hideSubmitButton) {
        controlStyle.height = 'auto';
      }

      var startDateWithAllTime = timePicker && startTimePickerProps && startTimePickerProps.config && startTimePickerProps.config.hour && startTimePickerProps.config.minute && startTimePickerProps.config.second;
      var startDateNeedTimePickerTitle = timePicker && (startDateWithAllTime || (0, _spauiUtils.isEmptyObject)(startTimePickerProps));
      var endDateWithAllTime = timePicker && endTimePickerProps && endTimePickerProps.config && endTimePickerProps.config.hour && endTimePickerProps.config.minute && endTimePickerProps.config.second;
      var endDateNeedTimePickerTitle = timePicker && (endDateWithAllTime || (0, _spauiUtils.isEmptyObject)(endTimePickerProps));
      var hasSelectDate = startData.date && endData.date; // 快捷选择日期组件

      var shourtCutPanelComponent = _react["default"].createElement(_shortcut_panel["default"], {
        useNewUI: useNewUI,
        locale: locale,
        setLabel: setLabel,
        classNameMap: classNameMap,
        format: format,
        getDateValue: getDateValue,
        unlimitedDateValue: unlimitedDateValue,
        unlimitedDateValueLabel: unlimitedDateValueLabel,
        startDateCanBeUnlimited: startDateCanBeUnlimited,
        endDateCanBeUnlimited: endDateCanBeUnlimited,
        type: "range",
        startData: startData,
        endData: endData,
        nowDateObject: nowDateObject,
        optionalStartDateData: optionalStartDateData,
        optionalEndDateData: optionalEndDateData,
        shortcuts: shortcuts,
        onChange: onSubmit,
        picker: picker,
        firstDayOfWeek: firstDayOfWeek,
        endDayOfWeek: endDayOfWeek
      });

      if (useNewUI) {
        var _classNames;

        return _react["default"].createElement("div", {
          className: classNameMap.DatePickerDropdownDataPanelClassName,
          ref: function ref(el) {
            _this4.dataPanel = el;
          },
          style: {
            '--date-panel-height': !showDatePicker && this.dataPanelHeight ? "".concat(this.dataPanelHeight, "px") : undefined,
            '--date-area-height': !showDatePicker && this.dateAreaHeight ? "".concat(this.dateAreaHeight, "px") : undefined
          }
        }, useShortcut ? _react["default"].createElement("div", {
          className: (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, classNameMap.DatePickerDropdownLeftFastControlClassName, true), _defineProperty(_classNames, classNameMap.DatePickerLeftPanelClassName, true), _classNames))
        }, shourtCutPanelComponent) : null, _react["default"].createElement("div", {
          className: classNameMap.DatePickerRightPanelClassName
        }, showDatePicker ? _react["default"].createElement("div", {
          className: classNameMap.DatePickerDateareasClassName,
          ref: function ref(el) {
            _this4.dateAreaDom = el;
          }
        }, _react["default"].createElement(_date_area_component["default"], _extends({
          type: "start"
        }, dateAreaConfig, {
          className: getSplitClassName(),
          htmlRef: function htmlRef(el) {
            _this4.startDateDom = el;
          }
        })), !hideEndDatePanel ? _react["default"].createElement(_date_area_component["default"], _extends({
          type: "end"
        }, dateAreaConfig, {
          year: endYear,
          month: endMonth,
          htmlRef: function htmlRef(el) {
            _this4.endDateDom = el;
          }
        })) : null) : timePicker ? _react["default"].createElement("div", {
          className: classNameMap.DatePickerTimeareasClassName
        }, _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classNameMap.DatePickerTimePickerClassName, {
            'with-all-time': startDateWithAllTime,
            'with-timepicker-title': startDateNeedTimePickerTitle
          })
        }, _react["default"].createElement("div", {
          className: classNameMap.DatePickerTimePickerCurrentDateClassName
        }, (0, _spauiUtils.joinDate)(startData, '起: xxxx 年 xx 月 xx 日')), _react["default"].createElement("div", {
          className: "date-timepicker-body"
        }, startDateNeedTimePickerTitle ? this.showTimePickerTitle(startTimePickerProps) : null, _react["default"].createElement(_spauiTimepicker["default"], _extends({}, startTimePickerProps, {
          beginTime: startTimePickerBeginTime,
          endTime: startTimePickerEndTime,
          value: startTimeValue,
          showPlaceholder: false,
          show: true,
          onChange: this.handleStartTimePickerChange
        })))), _react["default"].createElement("div", {
          className: (0, _classnames["default"])(classNameMap.DatePickerTimePickerClassName, {
            'with-all-time': startDateWithAllTime,
            'with-timepicker-title': startDateNeedTimePickerTitle
          })
        }, _react["default"].createElement("div", {
          className: classNameMap.DatePickerTimePickerCurrentDateClassName
        }, (0, _spauiUtils.joinDate)(endData, '止: xxxx 年 xx 月 xx 日')), _react["default"].createElement("div", {
          className: "date-timepicker-body"
        }, endDateNeedTimePickerTitle ? this.showTimePickerTitle(endTimePickerProps) : null, _react["default"].createElement(_spauiTimepicker["default"], _extends({}, endTimePickerProps, {
          beginTime: endTimePickerBeginTime,
          endTime: endTimePickerEndTime,
          value: endTimeValue,
          showPlaceholder: false,
          show: true,
          onChange: this.handleEndTimePickerChange
        }))))) : null, showPanelFooter ? _react["default"].createElement("div", {
          className: classNameMap.DatePickerDataFootClassName
        }, _react["default"].createElement("div", {
          className: classNameMap.DatePickerLeftDataFootClassName
        }, hasSelectDate ? _react["default"].createElement("div", {
          className: "date-tips"
        }, "\u5DF2\u9009\u62E9 ", (0, _index.getTwoDateDifference)(startData, endData) + 1, " \u5929") : null), _react["default"].createElement("div", {
          className: classNameMap.DatePickerRightDataFootClassName
        }, timePicker ? _react["default"].createElement("a", {
          className: (0, _classnames["default"])({
            'spaui-cursor-pointer': hasSelectDate,
            'spaui-cursor-disabled': !hasSelectDate
          }),
          onClick: hasSelectDate ? this.toggleDateOrTimePicker : undefined
        }, showDatePicker ? '选择时间' : '选择日期') : null, timePicker || !hideSubmitButton ? _react["default"].createElement(_spauiButton["default"], {
          disabled: disabled,
          displayType: "primary",
          onClick: this.handleSubmit
        }, locale.submitLabel) : null)) : null));
      }

      return _react["default"].createElement("div", null, _react["default"].createElement("div", {
        className: "clearfix",
        ref: function ref(el) {
          _this4.dateAreaDom = el;
        }
      }, _react["default"].createElement(_date_area_component["default"], _extends({
        type: "start"
      }, dateAreaConfig, {
        className: getSplitClassName(),
        htmlRef: function htmlRef(el) {
          _this4.startDateDom = el;
        }
      })), !hideEndDatePanel ? _react["default"].createElement(_date_area_component["default"], _extends({
        type: "end"
      }, dateAreaConfig, {
        year: endYear,
        month: endMonth,
        htmlRef: function htmlRef(el) {
          _this4.endDateDom = el;
        }
      })) : null, timePicker ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.DatePickerTimePickerClassName, {
          'with-all-time': startDateWithAllTime,
          'with-timepicker-title': startDateNeedTimePickerTitle
        })
      }, _react["default"].createElement("div", {
        className: classNameMap.DatePickerTimePickerCurrentDateClassName
      }, (0, _spauiUtils.joinDate)(startData, 'xxxx.xx.xx') || '起始日期'), !startData.date ? _react["default"].createElement("div", {
        className: classNameMap.DatePickerTimePickerTipClassName
      }, "\u8BF7\u5148\u9009\u62E9\u8D77\u59CB\u65E5\u671F") : _react["default"].createElement("div", null, startDateNeedTimePickerTitle ? this.showTimePickerTitle(startTimePickerProps) : null, _react["default"].createElement(_spauiTimepicker["default"], _extends({}, startTimePickerProps, {
        beginTime: startTimePickerBeginTime,
        endTime: startTimePickerEndTime,
        value: startTimeValue,
        showPlaceholder: false,
        show: true,
        onChange: this.handleStartTimePickerChange
      })))) : null, timePicker ? _react["default"].createElement("div", {
        className: (0, _classnames["default"])(classNameMap.DatePickerTimePickerClassName, {
          'with-all-time': endDateWithAllTime,
          'with-timepicker-title': endDateNeedTimePickerTitle
        })
      }, _react["default"].createElement("div", {
        className: classNameMap.DatePickerTimePickerCurrentDateClassName
      }, (0, _spauiUtils.joinDate)(endData, 'xxxx.xx.xx') || '结束日期'), !endData.date ? _react["default"].createElement("div", {
        className: classNameMap.DatePickerTimePickerTipClassName
      }, "\u8BF7\u5148\u9009\u62E9\u7ED3\u675F\u65E5\u671F") : _react["default"].createElement("div", null, endDateNeedTimePickerTitle ? this.showTimePickerTitle(endTimePickerProps) : null, _react["default"].createElement(_spauiTimepicker["default"], _extends({}, endTimePickerProps, {
        beginTime: endTimePickerBeginTime,
        endTime: endTimePickerEndTime,
        value: endTimeValue,
        showPlaceholder: false,
        show: true,
        onChange: this.handleEndTimePickerChange
      })))) : null), _react["default"].createElement("div", {
        className: "clearfix ".concat(classNameMap.DatePickerFastControlClassName),
        style: controlStyle
      }, useShortcut ? shourtCutPanelComponent : null, timePicker || !hideSubmitButton ? _react["default"].createElement(_spauiButton["default"], {
        disabled: disabled,
        displayType: "primary",
        onClick: this.handleSubmit
      }, locale.submitLabel) : null, timePicker || !hideSubmitButton ? _react["default"].createElement(_spauiButton["default"], {
        displayType: "default",
        onClick: onOpen
      }, locale.cancelLabel) : null));
    }
  }]);

  return RangeDatePanel;
}(_react.PureComponent);

var _default = RangeDatePanel;
exports["default"] = _default;